import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SubBrandCard } from '../components/SubBrandCard';
import { Footer } from '../components/Footer';
import { Palmtree, Building, Film, Shirt, Disc, Megaphone } from 'lucide-react';
export function HomePage() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-blue-200 selection:text-blue-900" data-id="element-175">
      <Header data-id="element-176" />

      <main data-id="element-177">
        <Hero data-id="element-178" />

        {/* Brands Section */}
        <section id="brands" className="py-24 relative" style={{
        backgroundColor: '#0D121D'
      }} data-id="element-179">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
            <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-181">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-182">
                Our Portfolio
              </h2>
              <p className="text-lg text-slate-300" data-id="element-183">
                Discover the diverse family of Twice Bourne companies, each
                committed to redefining standards in their respective
                industries.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-184">
              {/* Explicitly writing out each card as per guidelines */}

              <SubBrandCard title="Twice Bourne Saint Lucia" description="Experience unparalleled luxury and breathtaking landscapes. Our Saint Lucia division focuses on premium hospitality and exclusive island experiences." icon={<Palmtree className="w-7 h-7" aria-hidden="true" data-id="element-186" />} href="/saint-lucia" data-id="element-185" />

              <SubBrandCard title="Twice Bourne Barndormatory" description="Redefining modern living spaces. We combine rustic charm with contemporary architecture to create unique, sustainable residential properties." icon={<Building className="w-7 h-7" aria-hidden="true" data-id="element-188" />} href="/barndormatory" data-id="element-187" />

              <SubBrandCard title="Twice Bourne Entertainment Films" description="Crafting compelling narratives that captivate audiences globally. Our production house is dedicated to high-quality cinematic storytelling." icon={<Film className="w-7 h-7" aria-hidden="true" data-id="element-190" />} href="/films" data-id="element-189" />

              <SubBrandCard title="Twice Bourne Apparels" description="Where comfort meets sophisticated design. Our apparel line offers premium, sustainably sourced clothing for the modern lifestyle." icon={<Shirt className="w-7 h-7" aria-hidden="true" data-id="element-192" />} href="/apparels" data-id="element-191" />

              <SubBrandCard title="Twice Bourne Records" description="Amplifying voices and creating timeless music. Our record label is dedicated to discovering and nurturing exceptional talent across all genres." icon={<Disc className="w-7 h-7" aria-hidden="true" data-id="element-194" />} href="/records" data-id="element-193" />

              <SubBrandCard title="Twice Bourne Advertising" description="Crafting compelling campaigns that resonate. Our advertising agency delivers strategic, creative solutions that drive measurable results." icon={<Megaphone className="w-7 h-7" aria-hidden="true" data-id="element-196" />} href="/advertising" data-id="element-195" />
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-197" />
    </div>;
}